import '@bolt/core/utils/optimized-resize';

export class BoltPanel {
  constructor(el) {
    if (!el) return;
    this.el = el;
    this.init();
  }

  init() {
    this.primary = this.el.querySelector('.js-bolt-panel-primary');
    this.secondary = this.el.querySelector('.js-bolt-panel-secondary');
    this.expandButton = this.el.querySelector('.js-bolt-panel-expand');
    this.collapseButton = this.el.querySelector('.js-bolt-panel-collapse');

    // set expand and collapse buttons to toggle visibility of the hidden content
    if (this.expandButton) {
      this.expandButton.addEventListener('click', () => {
        this.secondary.setAttribute('aria-expanded', 'true');
      });
    }
    if (this.collapseButton) {
      this.collapseButton.addEventListener('click', () => {
        this.secondary.setAttribute('aria-expanded', 'false');
      });
    }

    if (this.secondary) {
      // ensure hidden content is not taller than visible content
      this.checkPanelHeight();

      // timeout allows parent components (such as slideshow) to finish rendering
      setTimeout(() => {
        this.checkPanelHeight();
      }, 250);

      // check again whenever page is resized
      window.addEventListener('throttledResize', () => {
        this.checkPanelHeight();
      });
    }
  }

  checkPanelHeight() {
    this.primary.style.minHeight = '0px';

    if (this.secondary.clientHeight > this.primary.clientHeight) {
      this.primary.style.minHeight = this.secondary.clientHeight + 'px';
    }
  }
}
